import type { FC, ReactNode } from 'react'

import { Minus, Plus } from 'lucide-react'
import { cn } from '@/lib/utils'
import { toFaDigits } from '@/lib/format'

interface QuantityStepperProps {
    value: number
    max: number
    min?: number
    onChange: (value: number) => void
    size?: 'sm' | 'md'
    disabled?: boolean
    className?: string
}

const QuantityStepper: FC<QuantityStepperProps> = ({ value, max, min = 1, onChange, size = 'md', disabled = false, className }): ReactNode => {
    const button = cn(
        'flex items-center justify-center text-foreground transition-colors hover:bg-muted disabled:cursor-not-allowed disabled:opacity-40',
        size === 'sm' ? 'size-8' : 'size-11'
    )

    return (
        <div className={cn('inline-flex items-center rounded-lg border border-input bg-card', className)} role='group' aria-label='تعداد'>
            <button
                type='button'
                className={cn(button, 'rounded-s-lg')}
                onClick={() => onChange(Math.min(max, value + 1))}
                disabled={disabled || value >= max}
                aria-label='افزایش تعداد'
            >
                <Plus className='size-4' />
            </button>

            <span className={cn('min-w-8 text-center font-medium tabular-nums', size === 'sm' ? 'text-sm' : 'text-base')} aria-live='polite'>
                {toFaDigits(value)}
            </span>

            <button
                type='button'
                className={cn(button, 'rounded-e-lg')}
                onClick={() => onChange(Math.max(min, value - 1))}
                disabled={disabled || value <= min}
                aria-label='کاهش تعداد'
            >
                <Minus className='size-4' />
            </button>
        </div>
    )
}

export default QuantityStepper
